module.exports = __webpack_public_path__ + "static/media/lego-head-401.5cf19d07.svg";